import NormalText from "./NormalText";
import * as theme from "../theme";

const ScoreBar = (props) => {
  const score = props.score;
  const alttext = props.alttext;
  const height = props.height ? props.height : "33%";
  const fontSize = props.fontSize ? props.fontSize : "";
  const noText = props.noText ? false : true;
  const barColor = props.color ? props.color : theme.COLORS.primary_navyblue;
  const bgBarColor = props.bgcolor
    ? props.bgcolor
    : theme.COLORS.scrollbarbackground;
  const common = {
    display: "flex",
    borderRadius: 5,
  };
  const parentDiv = {
    justifyContent: "flex-start",
    position: "relative",
    height: height,
    color: "white",
    width: "100%",
    textAlign: "center",
    backgroundColor: bgBarColor,
    ...common,
  };
  const childDiv = {
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: Math.round(score) + "%",
    backgroundColor: barColor,
    ...common,
  };
  return (
    <div style={parentDiv}>
      <div style={childDiv}></div>
      {noText && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <NormalText
            text={alttext ? alttext : score}
            fontSize={fontSize}
          ></NormalText>
        </div>
      )}
    </div>
  );
};

export default ScoreBar;
